import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button } from 'loyal-react'
import AddToCartButton from 'Checkout/Cart/AddToCartButton'
import AriaModal from 'react-aria-modal'

class VerifyItemsCart extends Component {
  getApplicationNode = () => {
    return document.querySelector('#root')
  }

  removeTabIndex () {
    setTimeout(() => {
      const contentModalVoltage = document.querySelector('#modal-items-cart')
      contentModalVoltage && contentModalVoltage.removeAttribute('tabindex')
    }, 300)
  }

  render () {
    return (
      <Fragment>
        {this.props.showModalItemsCart && <AriaModal
          titleText='Você tem produto(s) de outro parceiro no carrinho'
          onExit={this.props.verifyItemsCart}
          initialFocus='#modal-items-cart'
          getApplicationNode={this.getApplicationNode}
          underlayStyle={{ paddingTop: '100px', zIndex: 9999 }}
          focusDialog
          alert
        >
          <div className='bg-none' data-campaign={process.env.REACT_APP_CATALOG_ID}>
            <div
              id='modal-items-cart'
              onBlur={this.removeTabIndex}
              tabIndex={0}
              className={`modal-voltage col-10 col-sm-7 bg-white py-3 mx-auto border-bottom-lg border-color-featured`}
            >
              <div className='row px-3'>
                <div className='col'>
                  <h1 id='modal-question-voltage' className='h3 txt-font-title'>Você tem produto(s) de outro parceiro no carrinho</h1>
                  <p>
                    Existem produtos de outro parceiro no seu carrinho. Finalize sua compra com os itens que já estão no carrinho ou os remova para adicionar este produto.
                  </p>
                </div>
              </div>
              <div className='col-12'>
                <div className='row'>
                  <div className='modal-back col-12 col-md-6 txt-right mt-3'>
                    <Button
                      id={'back-product'}
                      name={'back-product'}
                      className='btn btn-sm mx-0'
                      text='Voltar'
                      onClick={this.props.verifyItemsCart}
                    />
                  </div>
                  <div className='modal-back col-12 col-md-6 txt-right mt-3'>
                    <AddToCartButton text={'Seguir com este produto'} removeItems sku={this.props.sku} vendorId={this.props.vendorId} goToCheckout={this.props.goToCheckout} className={this.props.className || ''} noIcon />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </AriaModal> }
      </Fragment>
    )
  }
}
VerifyItemsCart.propTypes = {
  sku: PropTypes.string,
  vendorId: PropTypes.string,
  className: PropTypes.string,
  goToCheckout: PropTypes.bool,
  showModalItemsCart: PropTypes.bool,
  verifyItemsCart: PropTypes.func
}

export default VerifyItemsCart



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/RedemptionSection/VerifyItemsCart/index.js